export const SEATERS_API_BASE_URL = import.meta.env.SEATERS_API_BASE_URL;
export const SEATERS_APP_BASE_URL = import.meta.env.SEATERS_APP_BASE_URL;
export const SEATERS_MARKETING_BASE_URL = import.meta.env
  .SEATERS_MARKETING_BASE_URL;
export const FAN_WEB_APP_API_BASE_URL = import.meta.env
  .FAN_WEB_APP_API_BASE_URL;
export const SEATERS_STATIC_URL = import.meta.env.SEATERS_STATIC_URL;
export const SEATERS_STATIC_BASE_URL = import.meta.env.SEATERS_STATIC_BASE_URL;
export const SEATERS_TINY_API_KEY = import.meta.env.SEATERS_TINY_API_KEY;
export const SEATERS_MAPS_KEY = import.meta.env.SEATERS_MAPS_KEY;
export const SEATERS_COMMIT_HASH = import.meta.env.SEATERS_COMMIT_HASH;

// Keep the shared package aligned with app-local env helpers.
export const PROD = import.meta.env.MODE === 'production';
export const DEV = import.meta.env.MODE === 'development';
export const QA = import.meta.env.MODE === 'qa';
export const MODE = import.meta.env.MODE;
